import "../../shimmer.css";

const AuthenticationButton = (props) => {
  return (
    <button
      disabled={props.process}
      aria-busy={Boolean(props.process)}
      onClick={props.onClick}
      className={
        props.className ||
        "w-full h-12 md:h-[52px] bg-[#664bc7] hover:bg-[#664bc7]/90 text-white transition-colors duration-200 text-base md:text-lg rounded relative animate-action-button"
      }
    >
      {props.process && (
        <div className="w-full h-full absolute top-0 left-0 flex justify-center items-center bg-black/50 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-6 w-6 text-white motion-safe:animate-spin"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M12 2v4" />
            <path d="m16.2 7.8 2.9-2.9" />
            <path d="M18 12h4" />
            <path d="m16.2 16.2 2.9 2.9" />
            <path d="M12 18v4" />
            <path d="m4.9 19.1 2.9-2.9" />
            <path d="M2 12h4" />
            <path d="m4.9 4.9 2.9 2.9" />
          </svg>
        </div>
      )}
      {props.name}
    </button>
  );
};

export default AuthenticationButton;
